import { Box, Chip } from '@mui/material';
import { Text } from '@qwickapps/react-framework';

interface TokenUsageCostProps {
  inputTokens?: number;
  outputTokens?: number;
  costUsd?: number;
}

export default function TokenUsageCost({ inputTokens, outputTokens, costUsd }: TokenUsageCostProps) {
  if (!inputTokens && !outputTokens && costUsd === undefined) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Text variant="caption" style={{ fontWeight: 'bold', display: 'block', marginBottom: 4, opacity: 0.7 }}>
        Token Usage & Cost
      </Text>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {inputTokens !== undefined && (
          <Chip
            label={`Input: ${inputTokens.toLocaleString()} tokens`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {outputTokens !== undefined && (
          <Chip
            label={`Output: ${outputTokens.toLocaleString()} tokens`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {(inputTokens !== undefined && outputTokens !== undefined) && (
          <Chip
            label={`Total: ${(inputTokens + outputTokens).toLocaleString()} tokens`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {costUsd !== undefined && costUsd > 0 && (
          <Chip
            label={`Cost: $${costUsd.toFixed(4)}`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
      </Box>
    </Box>
  );
}
